import React from "react";
import EditableText from "./EditableText";
import { useContent } from "../context/ContentContext";

export default function About() {
  const { content } = useContent();
  const about = content?.about;
  if (!about) return null;

  const stats = [
    { value: about.stat1_value, label: about.stat1_label, valuePath: "about.stat1_value", labelPath: "about.stat1_label" },
    { value: about.stat2_value, label: about.stat2_label, valuePath: "about.stat2_value", labelPath: "about.stat2_label" },
    { value: about.stat3_value, label: about.stat3_label, valuePath: "about.stat3_value", labelPath: "about.stat3_label" },
  ].filter((s) => (s.value && s.value.trim()) || (s.label && s.label.trim()));
  const gridCols = stats.length === 2 ? "md:grid-cols-2" : stats.length === 1 ? "md:grid-cols-1" : "md:grid-cols-3";

  return (
    <section
      id="about"
      className="relative py-24 md:py-32 bg-[#F9F8F6]"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-7 md:col-start-1">
            <EditableText
              path="about.overline"
              value={about.overline}
              as="div"
              className="text-[#4A4F6B] uppercase text-xs tracking-[0.3em] font-semibold mb-6"
              testId="about-overline"
            />
            <EditableText
              path="about.heading"
              value={about.heading}
              as="h2"
              multiline
              className="font-serif text-[#1A1D1A] text-2xl md:text-3xl lg:text-[34px] leading-[1.2] tracking-tight font-medium mb-10 max-w-xl text-balance"
              testId="about-heading"
            />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-6 text-[#1A1D1A]/85">
              <EditableText
                path="about.paragraph1"
                value={about.paragraph1}
                as="p"
                multiline
                className="text-sm md:text-[15px] leading-relaxed"
                testId="about-paragraph-1"
              />
              <EditableText
                path="about.paragraph2"
                value={about.paragraph2}
                as="p"
                multiline
                className="text-sm md:text-[15px] leading-relaxed"
                testId="about-paragraph-2"
              />
            </div>
          </div>

          <div className="md:col-span-5 md:col-start-8">
            <div className="relative img-grain overflow-hidden rounded-2xl">
              <img
                src={about.image_url}
                alt="Alpha Trust renewable energy"
                className="w-full h-[360px] md:h-[520px] object-cover"
                data-testid="about-image"
              />
            </div>
          </div>
        </div>

        <div className={`mt-20 md:mt-28 border-t border-[#E2E0D8] pt-12 grid grid-cols-1 ${gridCols} gap-10 md:gap-16`}>
          {stats.map((s, i) => (
            <div key={i} data-testid={`about-stat-${i + 1}`}>
              <EditableText
                path={s.valuePath}
                value={s.value}
                as="div"
                className="font-serif text-[#00025C] text-5xl md:text-6xl font-medium mb-3 leading-none"
                testId={`about-stat-${i + 1}-value`}
              />
              <EditableText
                path={s.labelPath}
                value={s.label}
                as="div"
                className="text-[#4A4F6B] uppercase text-xs tracking-[0.25em]"
                testId={`about-stat-${i + 1}-label`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
